import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

// ── Formularios que llenó un contacto (2026-08-26) ───────────────────────────
// Trae los vinculados solos al llegar (por email o teléfono) Y los vinculados a
// mano: los dos caminos escriben el mismo contact_id, así que es una sola
// consulta y no dos fuentes que puedan discrepar.

export interface ContactSubmission {
  id: number;
  formId: string;
  formName: string;
  submittedName: string | null;
  submittedEmail: string | null;
  reviewedAt: string | null;
  createdAt: string;
}

export function useContactSubmissions(contactId: number | null) {
  return useQuery<{ submissions: ContactSubmission[] }>({
    queryKey: ['contact-submissions', contactId],
    queryFn: () => api.get(`/api/contacts/${contactId}/submissions`),
    enabled: contactId != null,
  });
}
